export const getInputValue = (ref) => {
    if (!ref.current) return '';

    if (ref.current instanceof HTMLInputElement) {
        return ref.current.value;
    }
    const nestedInput = ref.current.querySelector?.('input');
    return nestedInput ? nestedInput.value : ref.current.value || '';
};

export const setInputValue = (ref, nuevoValor) => {
    
    if (!ref.current) return;
    

    if (ref.current instanceof HTMLInputElement || 'value' in ref.current) {
        ref.current.value = nuevoValor;
    } else if (ref.current.querySelector) {
        const inputInterno = ref.current.querySelector('input');
        if (inputInterno) inputInterno.value = nuevoValor;
    }

    // 3. OPCIONAL: Disparar evento para que los estilos de PrimeReact se actualicen
    // Esto evita que el Label se encime sobre el texto.
    const evento = new Event('input', { bubbles: true });
    (ref.current.getInput?.() || ref.current).dispatchEvent(evento);
};
